import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Product from './Product';
import styles from './Product.styles';

const mapStateToProps = ({ user }) => {
  const {
    data: { brand },
  } = user;

  return {
    mainBrand: brand,
  };
};

export default compose(withStyles(styles), withRouter, connect(mapStateToProps, null))(Product);
